import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import "./cellActions.css";
import { ArrowBtnMobile, notificationSmallIcon } from "../../../assets/logos/icons";
import { Tooltip } from "@progress/kendo-react-tooltip";


export default function cellActions({
  setSelectedItem,
  setShowDetails,
  setNameComponentUser,
  iconOneActive, //Active first icon
  disableFirst = false,
  iconTwoActive, //Active two icon
  iconThirdActive, //Active third icon
  iconFourthActive, //Active fourth icon
  iconFifthActive, //Active fifth icon
  iconTrashActive, // Active trash icon
  disableTrash = false,
  labelOneActions, //Label first icon
  labelTwoActions, //Label second icon, first option
  labelTwoActions2, //Label second icon, second option
  labelThirdActions, //Label third icon
  labelFourthActions, //Label fourth icon
  labelFifthActions, //Label fifth icon
  labelTrashActions, //Label trash icon
  styleCol4, //Class to td (col4) from table, especifies width
  activeDialog1, //True to active dialog and false to change page
  btnOpenDialog1, //Function to open dialog in cellAction
  iconOneActiveSelected, //True or false if you use value from array
  iconTwoActiveSelected, //Active one button item, True or false if you use value from array
  showDialogYesNo, //Value true or false, to dialog
  activeDialog2, //Function to open dialog on second btn in cellAction
  btnOpenDialog2, //Function to open dialog on second btn in cellAction
  showDialogYesNo2, //Value true or false, to dialog on second btn,
  paddingBtns, //True or false if want padding between btns
  mobileFunction,
  tooltipTrashIcon, // Trash icon tooltip text
  tooltipFirstText, // Tooltip for first button (restore)
  activeDialogTrash, //True to open dialog and false to change page
  btnOpenDialogTrash, //Function to open dialog on trash icon
  showDialogYesNoTrash, //Value true or false, for dialog on trash icon
  iconFifth
}) {
  return class extends GridCell {
    handleClick = (dataItem) => {
      return function (e) {
        setSelectedItem(dataItem);
        setNameComponentUser(e.currentTarget.dataset.id);
        setTimeout(() => {
          setShowDetails(true);
        }, 500);
      };
    };

    render() {
      const { dataItem } = this.props
      const showTrashIcon = dataItem.hasOwnProperty('iconTrashActive')
        ? dataItem.iconTrashActive
        : iconTrashActive

      // Allow per-row overrides via dataItem.*; fall back to global props
      const effectiveDisableFirst = dataItem.hasOwnProperty('disableFirst')
        ? dataItem.disableFirst
        : disableFirst
      const effectiveDisableTrash = dataItem.hasOwnProperty('disableTrash')
        ? dataItem.disableTrash
        : disableTrash
      const firstTooltipText = dataItem.hasOwnProperty('tooltipFirstText')
        ? dataItem.tooltipFirstText
        : tooltipFirstText
      const trashTooltipText = dataItem.hasOwnProperty('tooltipTrashIcon')
        ? dataItem.tooltipTrashIcon
        : tooltipTrashIcon
      //Validate with element from array to first action button
      if (iconOneActiveSelected && iconOneActiveSelected !== "") {
        iconOneActive = this.props.dataItem[iconOneActiveSelected];
      }
      //Validate with element from array to second action button
      if (iconTwoActiveSelected && iconTwoActiveSelected !== "") {
        labelTwoActions = this.props.dataItem[labelTwoActions2];
      }
      return (
        <td
          className={`${styleCol4} ${this.props.className}`}
          style={this.props.style}
          role={"gridcell"}
          aria-colindex={this.props.ariaColumnIndex}
          aria-selected={this.props.isSelected}
          colSpan={this.props.colSpan}
        >
          <div>
            <div className="cellActions-containerAvatar">
              <div
                className='cellActions-mobileExpanded'
                onClick={(mobileFunction) ? () => btnOpenDialog1(this.props.dataItem) : this.handleClick(this.props.dataItem)}
                data-id={labelFourthActions}
              >
                <img
                  className='cellActions-icon-arrow'
                  alt={'cellActions-arrow'}
                  src={ArrowBtnMobile}
                />
              </div>
              {/* First icon  */}
              {iconOneActive ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <Tooltip
                    openDelay={600}
                    position="top"
                    anchorElement="target"
                    tooltipClassName="tooltipGeneralStyle"
                  >
                    <button
                      className="cellActions-btn"
                      onClick={
                        effectiveDisableFirst
                          ? () => { }
                          : activeDialog1
                            ? () => btnOpenDialog1(this.props.dataItem, showDialogYesNo)
                            : this.handleClick(this.props.dataItem)
                      }
                      data-id={labelOneActions}
                      title={firstTooltipText}
                      disabled={effectiveDisableFirst}
                    >
                      <p className="cellActions-textBotton">{labelOneActions}</p>
                    </button>
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
              {this.props.dataItem.notifyBtn ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <button
                    className="cellActions-btn"
                    onClick={
                      effectiveDisableFirst
                        ? () => { }
                        : activeDialog1
                          ? () => btnOpenDialog1(this.props.dataItem, showDialogYesNo)
                          : this.handleClick(this.props.dataItem)
                    }
                    data-id={labelOneActions}
                    disabled={effectiveDisableFirst}
                    title={tooltipFirstText}
                    style={effectiveDisableFirst ? { opacity: 0.5 } : undefined}
                  >
                    <p className="cellActions-textBotton">{labelOneActions}</p>
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* Second icon  */}
              {iconTwoActive ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <button
                    className="cellActions-btn"
                    onClick={activeDialog2 ? () => btnOpenDialog2(this.props.dataItem, showDialogYesNo2) : this.handleClick(this.props.dataItem)}
                    data-id={labelTwoActions}
                  >
                    <p className="cellActions-textBotton">{labelTwoActions}</p>
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* Third icon  */}
              {iconThirdActive ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <button
                    className="cellActions-btn"
                    onClick={this.handleClick(this.props.dataItem)}
                    data-id={labelThirdActions}
                  >
                    <p className="cellActions-textBotton">{labelThirdActions}</p>
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* Fourth icon  */}
              {iconFourthActive ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <button
                    className="cellActions-btn"
                    onClick={this.handleClick(this.props.dataItem)}
                    data-id={labelFourthActions}
                  >
                    <p className="cellActions-textBotton">{labelFourthActions}</p>
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* Fifth icon  */}
              {iconFifthActive ? (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  {iconFifth ? <img width={25} alt="notification" src={notificationSmallIcon} onClick={this.handleClick(this.props.dataItem)}
                    data-id={labelFifthActions} />
                    :
                    <button
                      className="cellActions-btn"
                      onClick={this.handleClick(this.props.dataItem)}
                      data-id={labelFifthActions}
                    >
                      <p className="cellActions-textBotton">{labelFifthActions}</p>
                    </button>
                  }
                </div>
              ) : (
                ""
              )}
              {/* Trash icon  */}
              {showTrashIcon && (
                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                  <Tooltip
                    openDelay={600}
                    position="top"
                    anchorElement="target"
                    tooltipClassName="tooltipGeneralStyle"
                  >
                    <button
                      className="cellActions-TrashBtn"
                      onClick={
                        effectiveDisableTrash
                          ? () => { }
                          : activeDialogTrash
                            ? () => btnOpenDialogTrash(this.props.dataItem, showDialogYesNoTrash)
                            : this.handleClick(this.props.dataItem)
                      }
                      data-id={labelTrashActions}
                      disabled={effectiveDisableTrash}
                    >
                      <i
                        title={trashTooltipText ? trashTooltipText : labelTrashActions}
                        className="k-icon k-i-delete k-i-trash"
                      />
                    </button>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        </td>
      );
    }
  };
}
